// CALL-796: valueFormatted, not value — a cell renderer bypasses the column's valueFormatter, so
// rendering the raw value would undo the formatting. Every column using this one declares a formatter.
const CellBorderRenderer = ({ valueFormatted, shouldHighlightDay }) => {
    const cellStyle = shouldHighlightDay ? { borderRight: '1px solid black' } : {};

    return <div style={cellStyle}>{valueFormatted}</div>;
};

export default CellBorderRenderer;
